/**
 * /home — unified hub landing.
 *
 * A single tile screen that contains BOTH systems: a CRM section and
 * an ERP section, each rendered with the same tile launcher used by
 * the per-app overviews. This is the common landing page for the whole
 * app — root (`/`) redirects here after login. Tiles are role-gated.
 */

import { createFileRoute } from "@tanstack/react-router";
import { Briefcase, Factory, LayoutGrid } from "lucide-react";

import { TileGrid, crmTiles, erpTiles } from "../components/AppTiles";
import { useAuthStore } from "../lib/auth";

export const Route = createFileRoute("/_app/home")({
  component: HomePage,
});

function HomePage() {
  const user = useAuthStore((s) => s.user);
  const role = user?.role ?? "sales";

  return (
    <div className="page-shell space-y-8 p-4 sm:p-6">
      <header className="space-y-1">
        <h1 className="flex items-center gap-2 text-2xl font-semibold tracking-tight">
          <LayoutGrid className="size-5 opacity-70" aria-hidden />
          Home
        </h1>
        <p className="text-sm opacity-60">
          Everything in one place — jump straight into CRM or ERP.
        </p>
      </header>

      <section className="space-y-3">
        <h2 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wider opacity-70">
          <Briefcase className="size-4" aria-hidden />
          CRM
        </h2>
        <TileGrid tiles={crmTiles(role)} />
      </section>

      <section className="space-y-3">
        <h2 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wider opacity-70">
          <Factory className="size-4" aria-hidden />
          ERP
        </h2>
        <TileGrid tiles={erpTiles(role)} />
      </section>
    </div>
  );
}
